import * as classNames from "classnames"
import { separateHourFromDateAndFormatToString } from "widgets/widgetsUtils"
import { ArticleCommentRenderProps } from "../../article/componentas/articleComments/articleCommentWrapper"
import { getTranslation } from "../../article/componentas/articleComments/translations";

export interface ArticleCommentGalhedUiProps {
    props: ArticleCommentRenderProps
}

export class ArticleCommentGalhedUi extends React.Component<ArticleCommentGalhedUiProps, {}> {
    render() {
        const { lang,
            comment: {
                text,
                author,
                pubDate,
            } } = this.props.props


        const articlePublishDate = separateHourFromDateAndFormatToString(pubDate, { showHour: false })


        return (
            <div id="articleComments" className="ArticleComment">
                <div className="topView" >
                    {author !== "" ? <span>  {`${author}`}   </span> : <span>{getTranslation(lang, "Anonymous")}</span>}
                </div>
                <div className="commentText">{text}</div>
                <span className="publishDate">{articlePublishDate}</span>
            </div>)
    }
}